import { animated, useSpring } from '@react-spring/web';
import { useEffect, useState } from 'react';

interface Props {
	children: React.ReactElement;
}

export const PulseTransition: React.FC<Props> = ({ children }) => {
	const [isPulsing, setPulsing] = useState(true);

	const style = useSpring({
		from: { scale: 1 },
		to: { scale: isPulsing ? 1.5 : 1 },
		config: { tension: 200, friction: 10 },
		reverse: isPulsing, // Obrací animaci zpět, když je isPulsing true
	});

	useEffect(() => {
		const timer = setTimeout(() => {
			setPulsing(false);
		}, 5000);
		return () => clearTimeout(timer);
	}, []);

	return <animated.div style={{ ...style }}>{children}</animated.div>;
};
